import { Link } from 'react-router-dom';
import { useApi } from '../lib/use-api';
import { relativeTime } from '../lib/api';
import { Card, Empty, ErrorNotice, Loading, Status } from '../components/ui';

interface DeviceListItem {
  deviceId: string;
  locationName: string;
  status: string;
  online: boolean;
  lastCheckinAt: string | null;
  firmwareVersion: string | null;
}

/** Wireframe B3 — the device dashboard, with a first-run empty state. */
export function Devices() {
  const devices = useApi<{ items: DeviceListItem[] }>('/devices');

  if (devices.loading) return <Loading />;

  const items = devices.data?.items ?? [];

  return (
    <>
      <div className="page-head">
        <h1>Your devices</h1>
        <p>{items.length === 0 ? 'Register your first device to get started.' : `${items.length} registered`}</p>
      </div>

      <ErrorNotice error={devices.error} />

      {items.length === 0 ? (
        <Card>
          <Empty title="No devices yet">
            <p className="muted">Register the NeteGate appliance installed at your venue.</p>
            <Link className="btn" to="/devices/new" style={{ display: 'inline-block', marginTop: 10 }}>
              Register your first device
            </Link>
          </Empty>
        </Card>
      ) : (
        <>
          <div style={{ marginBottom: 14 }}>
            <Link className="btn" to="/devices/new" style={{ display: 'inline-block' }}>
              + Register device
            </Link>
          </div>
          <Card>
            {items.map((device) => (
              <Link
                key={device.deviceId}
                to={`/devices/${device.deviceId}`}
                className="device-row"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                <div>
                  <div className="name">{device.locationName}</div>
                  <div className="meta">
                    <span className="mono">{device.deviceId}</span>
                    {' · '}
                    {device.online ? `checked in ${relativeTime(device.lastCheckinAt)}` : 'not reporting'}
                  </div>
                </div>
                <Status online={device.online} status={device.status} />
              </Link>
            ))}
          </Card>
        </>
      )}
    </>
  );
}
